module.exports = __webpack_public_path__ + "static/img/masterclassSucceed.c1460848.png";